/* eslint-disable default-case */
/* eslint-disable import/no-cycle */
import React from 'react';
import { Esi } from '@empiriecom/module-components/Esi';
import useConfig from '../hooks/useConfig';
import Contact from '../Forms/Contact/index';
import RateProtection from '../Forms/RateProtection';
export var PlaceholderTypes;
(function (PlaceholderTypes) {
    PlaceholderTypes["NewsletterAgnitas"] = "newsletter-agnitas";
    PlaceholderTypes["HomepageMagazin"] = "homepage-magazin";
    PlaceholderTypes["ContactForm"] = "contactForm";
    PlaceholderTypes["RateProtection"] = "formRsv";
})(PlaceholderTypes || (PlaceholderTypes = {}));
var Placeholder = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var contentData = _a.contentData;
    var config = useConfig();
    var fetchUrl = (_c = (_b = config === null || config === void 0 ? void 0 : config.esiUrls) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.homepageNewsletter;
    var fetchUrlMagazin = (_e = (_d = config === null || config === void 0 ? void 0 : config.esiUrlHomepageMagazin) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e.url;
    switch (contentData.field_placeholder_variants) {
        case PlaceholderTypes.NewsletterAgnitas:
            if (fetchUrl) {
                return (React.createElement("div", { className: "cms-placeholder-wrapper", "data-testid": "cms-placeholder-newsletter-agnitas" },
                    React.createElement(Esi, { src: fetchUrl })));
            }
            break;
        case PlaceholderTypes.HomepageMagazin:
            if (fetchUrlMagazin && config.esiUrlHomepageMagazin.enabled) {
                return (React.createElement("div", { className: "cms-placeholder-wrapper", "data-testid": "cms-placeholder-homepage-magazin" },
                    React.createElement(Esi, { src: fetchUrlMagazin })));
            }
            break;
        case PlaceholderTypes.ContactForm:
            return React.createElement(Contact, { companyId: (_g = (_f = config === null || config === void 0 ? void 0 : config.global) === null || _f === void 0 ? void 0 : _f.values) === null || _g === void 0 ? void 0 : _g.FRAGMENT_COMPANYID });
        case PlaceholderTypes.RateProtection:
            return React.createElement(RateProtection, { companyId: (_j = (_h = config === null || config === void 0 ? void 0 : config.global) === null || _h === void 0 ? void 0 : _h.values) === null || _j === void 0 ? void 0 : _j.FRAGMENT_COMPANYID });
    }
    return React.createElement("div", { "data-testid": "placeholder-not-found" });
};
export default Placeholder;
//# sourceMappingURL=index.js.map